import React, { useMemo } from 'react';
import { Document } from 'src/types/flow';
import { Col, Row, Text } from 'rsuite';
import { CustomHTML } from '../../../components/common/CustomHTML';
import { ConfigDocument } from 'src/types/configuration';
import { isAttachedFileValid } from 'src/common/documents';

interface DocumentsProps {
  documents?: Document;
  configDocuments: ConfigDocument[];
}
export const Documents = ({ documents, configDocuments }: DocumentsProps) => {
  const entries = useMemo(
    () => (documents ? Object.entries(documents) : []),
    [documents]
  );

  const hasDocuments = useMemo(
    () =>
      entries.some(([, docValue]) =>
        docValue?.attachedFiles?.some(isAttachedFileValid)
      ),
    [entries]
  );

  if (!documents || !hasDocuments) {
    return <Text>No documents uploaded</Text>;
  }

  return (
    <Row>
      <Col
        xs={24}
        lg={12}
      >
        <h2>Verification Documents</h2>
        {entries.map(([docKey, docValue], docGroupIdx) => {
          const docInfo = configDocuments?.find((d) => d.file_key === docKey);
          const validFiles =
            docValue?.attachedFiles?.filter(isAttachedFileValid) ?? [];
          const docs = validFiles.map((file, idx) => (
            <Text key={`document_${file.blobFile?.name}_${idx}`}>
              {file.blobFile?.name}
            </Text>
          ));
          if (!docs || docs.length === 0) return <></>;
          return (
            <div key={`document_set_${docGroupIdx}`}>
              <Text className="text-bold">
                <CustomHTML text={docInfo?.title ?? ''} />
              </Text>
              {docs}
            </div>
          );
        })}
      </Col>
    </Row>
  );
};
